import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    title: 'Bulls Barber',
    loadComponent: () =>
      import('./pages/home/home').then((m) => m.Home),
  },
  {
    path: 'arak',
    title: 'Árak | Bulls Barber',
    loadComponent: () =>
      import('./pages/pricing/pricing').then((m) => m.Pricing),
  },
  {
    path: 'galeria',
    title: 'Galéria | Bulls Barber',
    loadComponent: () =>
      import('./pages/gallery/gallery').then((m) => m.Gallery),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
